// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3Q1wB","rootSmall":"AddTileButton_rootSmall__3NPCt"};